import { Component, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { chunk, set } from 'lodash';

@Component({
  selector: 'xilo-mono-form-viewer-table',
  templateUrl: './table.type.html',
  styleUrls: ['../../assets/custom-theme.scss', './table.component.scss'],
})
export class CustomTableComponent extends FieldArrayType implements OnInit {
  columns = [];
  tables = [];

  get fieldHasMultiple() {
    return this.field?.fieldGroup?.length > 1;
  }

  get isValid() {
    return this.formControl?.valid;
  }

  constructor() {
    super();
  }

  ngOnInit() {
    this.generateColumns();
    if (this.field.fieldGroup && this.field.fieldGroup.length === 0) {
      this.add();
    }
    this.field.templateOptions = {
      ...this.field.templateOptions,
      onAdd: () => {
        this.add();
      },
      onRemove: (index: number) => {
        this.remove(index);
      },
    };
  }

  onHide() {
    if (this.field.hide || this.field.type === 'text') {
      return true;
    }
    return false;
  }

  onAdd() {
    this.add();
  }

  onRemove() {
    const lastRowIndex = this.field.fieldGroup.length - 1;
    this.remove(lastRowIndex);
  }

  resizeColumn(width: string) {
    if (width) {
      return {
        width,
      };
    }
  }

  generateColumns() {
    this.field.fieldArray.fieldGroup.map((f) => (f.wrappers = ['table-field']));
  }
}
